var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-page"},[_c('Header'),_c('v-main',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"page d-flex"},[_vm._t("default")],2)])]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }